import { createReactContext } from "utils/createReactContext"

export const [ShoppingContext, useShoppingContext] = createReactContext()